import DWInstallationPlatforms from "../../../../contents/docs/data-warehouse/_snippets/dw-installation-platforms";
import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconGraph, IconPiggyBank, IconFlask } from '@posthog/icons';
import OSButton from 'components/OSButton';
import * as React from 'react';
export default {
  DWInstallationPlatforms,
  QuestLog,
  QuestLogItem,
  IconGraph,
  IconPiggyBank,
  IconFlask,
  OSButton,
  React
};